module.exports = __webpack_public_path__ + "img/more-v.a020630c.svg";